import styled from 'styled-components'

export const Container = styled.div`
    padding: 80px 0;
    text-align: center;
`

export const Title = styled.h1`
    font-size: 2rem;
    font-weight: 700;
    text-align: center;
`

export const DataContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    margin: 40px 0;
`

export const ChartContainer = styled.div`
    height: 400px;
    width: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const CountContainer = styled.div`
    height: 400px;
    width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    font-size: 1.3rem;
    font-weight: 500;
`

export const Count = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    span {
      line-height: 1.1;
    }

    span:nth-child(1) {
      font-size: 2rem;
      font-weight: 700;
    }
`
